import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import PropTypes from 'prop-types';
import ImageHelper from './ImageHelper';
var propTypes = {
  // Rendered on success
  children: PropTypes.element.isRequired,
  // Rendered during load
  loadingIndicator: PropTypes.node,
  // Array of image urls to be preloaded
  images: PropTypes.arrayOf(PropTypes.string),
  // If set, the preloader will automatically show
  // the children content after this amount of time
  autoResolveDelay: PropTypes.number,
  // Error callback. Is passed the error
  onError: PropTypes.func,
  // Success callback
  onSuccess: PropTypes.func,
  // Whether or not we should still show the content
  // even if there is a preloading error
  resolveOnError: PropTypes.bool,
  // Whether or not we should mount the child content after
  // images have finished loading (or after autoResolveDelay)
  mountChildren: PropTypes.bool
};
var defaultProps = {
  loadingIndicator: null,
  images: [],
  autoResolveDelay: 0,
  onError: null,
  onSuccess: null,
  resolveOnError: true,
  mountChildren: true
};

var Preload =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Preload, _React$Component);

  function Preload() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Preload);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Preload)).call.apply(_getPrototypeOf2, [this].concat(args))), _this._mounted = false, _this.state = {
      ready: false
    }, _this.loadImages = function () {
      var _this$props = _this.props,
          images = _this$props.images,
          autoResolveDelay = _this$props.autoResolveDelay;
      ImageHelper.loadImages(images).then(_this._handleSuccess, _this._handleError);

      if (autoResolveDelay && autoResolveDelay > 0) {
        _this.autoResolveTimeout = setTimeout(_this._handleAutoResolve, autoResolveDelay);
      }
    }, _this._handleAutoResolve = function () {
      _this._handleSuccess({
        didAutoResolve: true
      });
    }, _this._handleSuccess = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          didError = _ref.didError,
          didAutoResolve = _ref.didAutoResolve;

      if (_this.autoResolveTimeout) {
        clearTimeout(_this.autoResolveTimeout);
        _this.autoResolveTimeout = null;
      }

      var ready = _this.state.ready;

      if (ready || !_this._mounted) {
        return;
      }

      _this.setState({
        ready: true
      });

      var onSuccess = _this.props.onSuccess;

      if (onSuccess) {
        onSuccess({
          didError: didError,
          didAutoResolve: didAutoResolve
        });
      }
    }, _this._handleError = function (err) {
      if (!_this._mounted) {
        return;
      }

      var _this$props2 = _this.props,
          resolveOnError = _this$props2.resolveOnError,
          onError = _this$props2.onError;

      if (resolveOnError) {
        _this._handleSuccess({
          didError: true,
          error: err
        });
      }

      if (onError) {
        onError(err);
      }
    }, _temp));
  }

  _createClass(Preload, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var images = this.props.images;

      if (!images || images.length === 0) {
        this._handleSuccess();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
      this.loadImages();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var images = this.props.images;
      var oldImages = new Set(prevProps.images);
      var hasChanged = false;

      for (var i = 0; i < images.length; i += 1) {
        var image = images[i];

        if (!oldImages.has(image)) {
          hasChanged = true;
          break;
        }
      }

      if (hasChanged) {
        this.loadImages();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;

      if (this.autoResolveTimeout) {
        clearTimeout(this.autoResolveTimeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var ready = this.state.ready;
      var _this$props3 = this.props,
          mountChildren = _this$props3.mountChildren,
          children = _this$props3.children,
          loadingIndicator = _this$props3.loadingIndicator;
      return ready && mountChildren ? children : loadingIndicator;
    }
  }]);

  return Preload;
}(React.Component);

Preload.propTypes = propTypes;
Preload.defaultProps = defaultProps;
export default Preload;